module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/routes/performance/performance-relocation/performance-relocation.component.scss
// module id = ./src/app/routes/performance/performance-relocation/performance-relocation.component.scss
// module chunks = 9